module.exports = __webpack_public_path__ + "img/duty2.fe3e0f3b.jpg";